import { render, staticRenderFns } from "./Otpbox.vue?vue&type=template&id=e2f7711c&lang=pug"
import script from "./Otpbox.vue?vue&type=script&lang=js"
export * from "./Otpbox.vue?vue&type=script&lang=js"
import style0 from "./Otpbox.vue?vue&type=style&index=0&id=e2f7711c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports